<template>
  <section class="bg-gradient-to-br from-amber-50 via-white to-amber-50/60 border-b border-amber-100/60 py-14">
    <div class="container mx-auto px-4 text-center">
      <p v-if="eyebrow" class="text-sm uppercase tracking-[0.6em] text-amber-500 mb-3 font-semibold">{{ eyebrow }}</p>
      <h1 class="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">{{ title }}</h1>
      <p v-if="subtitle" class="mt-4 max-w-2xl mx-auto text-gray-600">{{ subtitle }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    eyebrow: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    }
  }
}
</script>
